import React, { useState, useContext, useCallback } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ShopItemType } from '../../../../../types/shop';
import ShopGrid from '../ShopGrid';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import ShopCommissionsControls from './ShopCommissionsControls';
import UploadMore from '../_partials/UploadMore';
import MoneyDeviationPublishedModal from '../../_partials/MoneyDeviationPublishedModal';
import s from '../ShopSection.scss';

export interface Props {
  className?: string;
  isOwner: boolean;
  isOpenForCommissions: boolean;
  onCreate: () => void;
}

const ShopCommissions: React.FC<Props> = ({
  className,
  isOpenForCommissions,
  isOwner,
  onCreate,
}) => {
  const isMobile = useContext(MobileContext);
  const [showSuccessModal, setShowSuccessModal] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return !!new URLSearchParams(window.location.search).get(
      'commission-publish-success'
    );
  });

  const dismissSuccessModal = useCallback(() => setShowSuccessModal(false), []);

  return (
    <BiLoggerContextProvider value={{ sectionname: 'Commissions' }}>
      <div className={s['section-with-no-header']}>
        {showSuccessModal && (
          <MoneyDeviationPublishedModal
            type="commission"
            onClose={dismissSuccessModal}
          />
        )}
        <ShopCommissionsControls />
        {(isOpenForCommissions || (isOwner && !isMobile)) && (
          <ShopGrid
            className={className}
            itemType={ShopItemType.COMMISSIONS}
            emptyState={false}
            uploadMore={
              <UploadMore
                itemType={ShopItemType.COMMISSIONS}
                onCreate={onCreate}
                biData={BiData<DefaultBiEvent>({
                  evid: 2,
                  click_info: 'create_commission',
                  sectionname: 'commission',
                })}
              />
            }
          />
        )}
      </div>
    </BiLoggerContextProvider>
  );
};
ShopCommissions.displayName = 'ShopCommissions';

export default withSectionFetchSpinner(
  ShopCommissions
) as React.ComponentType<Props>;
